import { isToday } from '../helpers/common';

export const getWorkedAcres = (workedData, range) => {
    const worked = { workedAcres: 0, isLinearAcres: false };
    const data = isToday(range) && workedData.today_data ? workedData.today_data : workedData.data;

    if (data && data.hasOwnProperty("linear_hectares")) {
        worked.workedAcres = (data.linear_hectares * 2.47105);
        worked.isLinearAcres = true;
    }
    else if (data && data.hasOwnProperty("worked_hectares")) {
        worked.workedAcres = (data.worked_hectares * 2.47105);
    }
    return worked;
}